<template>
  <v-dialog v-model="mostrar" persistent max-width="600" hide-overlay transition="scale-transition">
    <v-card>
        <v-toolbar  dense color="blue-grey darken-1" dark flat class="text-h6">Generar reporte</v-toolbar>
        <v-container>
          <v-row wrap justify="center">
            <v-col md="4">
              <v-select 
                v-model="tipoSel"
                :items="tipo"
                label="Tipo:"
                outlined
                dense
              />
            </v-col>
            <v-col md="4">
              <v-select 
                v-model="numero.mesSel"
                :items="numero.meses"
                label="Mes:"
                outlined
                dense
              />
            </v-col>
            <v-col md="4">
              <v-select 
                v-model="numero.anio"
                :items="numero.anios"
                label="Año:"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </v-container>
        <v-col
          v-if="loading"
          class="text-subtitle-2 text-center"
          cols="12"
        >Generando archivo</v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          rounded
          color="blue-grey darken-1"
        ></v-progress-linear>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey darken-1" 
          small 
          outlined 
          :disabled="loading" 
          @click="$emit('cancelar')">Cancelar</v-btn>
          <v-btn color="blue-grey darken-1" 
          small
          dark
          :loading="loading" 
          @click="generarReporte()">Generar reporte</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {DateTime} from 'luxon';
import { generarReporteService } from './oficiosGenerados.service';

export default {
  name: 'crearReporteGenerados',
  props: {
    mostrar: { Type: Boolean, default: () => false},
    reporte: { Type: Number, default: () => 1}
  },
  data: () => ({
    loading: false,
    numero: {
      meses: [
        { value: 1, text: 'Enero'},
        { value: 2, text: 'Febrero'},
        { value: 3, text: 'Marzo'},
        { value: 4, text: 'Abril'},
        { value: 5, text: 'Mayo'},
        { value: 6, text: 'Junio'},
        { value: 7, text: 'Julio'},
        { value: 8, text: 'Agosto'},
        { value: 9, text: 'Septiembre'},
        { value: 10, text: 'Octubre'},
        { value: 11, text: 'Noviembre'},
        { value: 12, text: 'Diciembre'}],
      mesSel: 1,
      anios: [DateTime.now().year-3,DateTime.now().year-2,DateTime.now().year-1,DateTime.now().year],
      anio: DateTime.now().year,
    },
    tipo: [
      { value: 1, text: 'SG'},
      { value: 2, text: 'CGU'},
    ],
    tipoSel: 1,
  }),
  methods: {
    async generarReporte() {
      try {
        this.loading = true;
        const serverResponse = await generarReporteService(
          this.numero.anio,
          this.numero.mesSel,
          this.tipoSel,
          this.reporte
        );
        this.loading = false;
        if(!serverResponse) this.$systemErrorMessage(serverResponse.mensaje);
        else {
          if (serverResponse.type == 'application/x-www-form-urlencoded') {
            const url = window.URL.createObjectURL(new Blob([serverResponse]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Reporte.xlsx");
            document.body.appendChild(link);
            link.click();

            this.$notify({
              group: "gral_notif",
              type: "success",
              duration: 1500,
              speed: 500,
              text: 'Reporte generado correctamente',
            });
          } else {
            throw new Error("Ocurrio un error al exportar el archivo");
          }
          this.$emit("cancelar");
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error.message);
      }
    }
  }

}
</script>

<style>

</style>